import React from 'react';

const SvgError = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 177 146"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.9
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1.389 2.038)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#E0E4E6",
  d: "M103.365.448H147a2 2 0 012 2V57a2 2 0 01-2 2H97.365a2 2 0 01-2-2V8.448a8 8 0 018-8z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 59.129,
  height: 59.129,
  x: 89.486,
  y: 0.448,
  stroke: "#3F4144",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  rx: 4
}), /*#__PURE__*/React.createElement("circle", {
  cx: 119.05,
  cy: 30.012,
  r: 18.505,
  fill: "#FFF",
  stroke: "#3F4144",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110.967,
  cy: 27.849,
  r: 3.245,
  fill: "#3F4144"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 127.376,
  cy: 27.849,
  r: 3.245,
  fill: "#3F4144"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#3F4144",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M113.021 37.002c2.01-1.44 4.02-2.16 6.03-2.16 2.01 0 4.019.72 6.029 2.16M1.599 78.154h171.734"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7ED987",
  stroke: "#3F4144",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M91.824 113.166c-6.127-3.106-10.212-1.996-12.257 3.33-1.4 3.649.707 6.784 6.322 9.406"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EDEFF0",
  stroke: "#3F4144",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M98.43 140.308c-9.008-4.803-13.906-12.602-11.523-18.964 3.04-8.117 13.639-14.676 29.935-4.616"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#3F4144",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M.238 118.873c36.568-9.996 57.188-15.98 61.859-17.95 5.123-2.161-27.528-10.17-30.141 0-.583 2.267 15.473 7.095 48.166 14.484"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EDEFF0",
  stroke: "#3F4144",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M122.153 123.952c-.011-2.048-.638-3.85-1.938-5.152-3.72-3.718-11.54-1.927-17.468 4-5.928 5.929-7.719 13.75-4 17.468 2.393 2.393 6.485 2.505 10.678.7"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#3F4144",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M115.704 134.592c1.043-.81 1.829-1.692 2.358-2.644"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#7ED987",
  d: "M104.815 137.387l10.616 6.377 2.76-.54.859-3.142-11.728-7.09-3.052 1.854z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#3F4144",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M114.192 143.024c1.121.707 2.136 1.06 3.221.707a2.907 2.907 0 001.867-3.664c-.302-.93-1.24-1.6-2.128-2.24M114.56 143.242l-9.298-5.368m2.96-5.127l9.297 5.368"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#3F4144",
  transform: "translate(94.587 6.531)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 2.329,
  cy: 2.807,
  r: 2.329
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48.123,
  cy: 2.807,
  r: 2.329
})), /*#__PURE__*/React.createElement("g", {
  fill: "#3F4144",
  transform: "translate(94.587 51.752)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 2.329,
  cy: 2.807,
  r: 2.329
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48.123,
  cy: 2.807,
  r: 2.329
})), /*#__PURE__*/React.createElement("path", {
  fill: "#7ED987",
  d: "M115.763 129.952l10.42 5.696 2.244-1.01.582-2.967-10.441-6.46-2.805.777-.425 1.776z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#3F4144",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M107.866 132.545c-1.473-.177-2.588.272-3.347 1.35-.76 1.077-.642 2.31.35 3.699M118.79 125.092c-1.506-.266-2.636.208-3.388 1.423-1.13 1.822-.094 3.364.914 3.857M124.915 135.365l-8.875-5.124m2.96-5.127l8.876 5.124M124.207 135.033c.99.487 2.257 1.138 3.342.786a2.907 2.907 0 001.867-3.663c-.302-.93-1.056-1.59-1.867-2.126"
})));

export default SvgError;